export type FeatureKeys =
    | "PROJ_MODULE"
    | "GBB"
    | "RECURR_VISIT"
    | "FP_FORM"
    | "MARKETING_CAMPAIGN"
    | "CLIENT_PORTAL"
    | "DYNAMIC_NOTIFICATION_TIME"
    | "TCE_FIRE_INTEGRATION"
    | "ATTENDANCE_STATUS"
    | "NEXT_VISIT_DUE"
    | "VISIT_DURATION_EDIT_ON_COMPLETE"
    | "CUST_PROSP"
    | "AUTO_SYNC_QBO"
    | "PAY_TERM_FIELD_INV_PDF"
    | "SYNC_BATC_INDV_PAY"
    | "JOB_TAGS"
    | "PAY_TERM_FIELD"
    | "RECURRING_INVOICE"
    | "OPEN_STATUS_LINE_ITEM"
    | "ATTCH_TICK_NOTES"
    | "SKIP_EQUIP_AGREMT"
    | "CUSTOM_INVOICE_PDF"
    |  "CALCULATE_OVER_TIME"
    | "PROGRESSIVE_BILLING"
    | "ADVANCED_TRACKING"
    | "ESTIMATE_REJECTION_REASON"
    | "AR_DUE_DATE"
    | "PRICE_BOOK"
    | "ATTCH_PAY_LINK_DEF"
    | "ADD_LINE_ITEMS_TO_DESC"
    | "INDV_LINE_ITEM_TAX"
    | "GOOGLE_CALENDAR"
    | "PERIODIC_LOCATION_TRACKING";

const FEATURE_KEYS_LIST: FeatureKeys[] = [
    "PROJ_MODULE",
    "GBB",
    "RECURR_VISIT",
    "FP_FORM",
    "MARKETING_CAMPAIGN",
    "CLIENT_PORTAL",
    "DYNAMIC_NOTIFICATION_TIME",
    "TCE_FIRE_INTEGRATION",
    "ATTENDANCE_STATUS",
    "NEXT_VISIT_DUE",
    "VISIT_DURATION_EDIT_ON_COMPLETE",
    "CUST_PROSP",
    "AUTO_SYNC_QBO",
    "PAY_TERM_FIELD_INV_PDF",
    "SYNC_BATC_INDV_PAY",
    "JOB_TAGS",
    "PAY_TERM_FIELD",
    "RECURRING_INVOICE",
    "OPEN_STATUS_LINE_ITEM",
    "ATTCH_TICK_NOTES",
    "SKIP_EQUIP_AGREMT",
    "CUSTOM_INVOICE_PDF",
    "CALCULATE_OVER_TIME",
    "PROGRESSIVE_BILLING",
    "ADVANCED_TRACKING",
    "ESTIMATE_REJECTION_REASON",
    "AR_DUE_DATE",
    "PRICE_BOOK",
    "ATTCH_PAY_LINK_DEF",
    "ADD_LINE_ITEMS_TO_DESC",
    "INDV_LINE_ITEM_TAX",
    "GOOGLE_CALENDAR",
    "PERIODIC_LOCATION_TRACKING",
];

export type FeatureKeysToNameMap = {
    [key in FeatureKeys]: string;
};

const FEATURE_KEY_TO_NAME_MAP: FeatureKeysToNameMap = {
    PROJ_MODULE: "Project Module",
    GBB: "Good Better Best",
    RECURR_VISIT: "Recurring Visit",
    FP_FORM: "FP Forms",
    MARKETING_CAMPAIGN: "Marketing Campaign",
    CLIENT_PORTAL: "Client Portal",
    DYNAMIC_NOTIFICATION_TIME: "Dynamic Notification Time",
    TCE_FIRE_INTEGRATION: "TCE Fire Integration",
    ATTENDANCE_STATUS: "Attendance Tracking/Global clock in/out",
    NEXT_VISIT_DUE: "Next Visit Due on Complete",
    VISIT_DURATION_EDIT_ON_COMPLETE: "Visit Duration Edit on Complete",
    CUST_PROSP: "Enable prospect to customer flow",
    AUTO_SYNC_QBO: "Enable auto-sync of payments QBO",
    PAY_TERM_FIELD_INV_PDF:
        "Show selected payment Term in Invoice/Estimate PDF",
    SYNC_BATC_INDV_PAY: "Sync batch payments as individual payment",
    JOB_TAGS: "Enable job tags and dependent feature",
    PAY_TERM_FIELD: "Enable Payment Term in Invoice/Estimate",
    RECURRING_INVOICE: "Enable Recurring Invoice",
    OPEN_STATUS_LINE_ITEM:
        "Show the open status of line items in UI and PDF (Estimate)",
    ATTCH_TICK_NOTES: "Ability to attach TicketNotes in invoice/Estimate PDF",
    SKIP_EQUIP_AGREMT: "Make equipment non mandatory for SA",
    CUSTOM_INVOICE_PDF: "Enable custom invoice PDF",
    CALCULATE_OVER_TIME: "Enable overtime calculation in timecard",
    PROGRESSIVE_BILLING: 'Enable progressive billing',
    ADVANCED_TRACKING: "Advanced Tracking",
    ESTIMATE_REJECTION_REASON: "Estimate Rejection Reasons",
    AR_DUE_DATE: "Show AR Due Date on Invoice",
    PRICE_BOOK: "Enable Price Book",
    ATTCH_PAY_LINK_DEF: "Attach default payment link sent in invoice billing email",
    ADD_LINE_ITEMS_TO_DESC: "Add Line Items to Description",
    INDV_LINE_ITEM_TAX: "Enable Individual Line Item Tax",
    GOOGLE_CALENDAR: "Enable Google Calendar",
    PERIODIC_LOCATION_TRACKING: "Enable Periodic Location Tracking",
};

export { FEATURE_KEYS_LIST, FEATURE_KEY_TO_NAME_MAP };
